<template>
  <div>
    <ejs-dialog
      ref='commonDialog'
      :buttons='btnMessage'
      :header='headerMessage'
      :animationSettings='animationSettings'
      :content='infoMessage'
      :showCloseIcon='closeIcon'
      closeOnEscape=false
      isModal=false
      v-bind:visible='false'
      cssClass='h-layer'
      zIndex='1200'
      height='210px'
      width='340'>
    </ejs-dialog>
  </div>
</template>

<script>
// const lanauage = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'zh';
const defaultInfo = ['操作成功!', '操作失败!'];
// const defaultTitle = [
//   '温馨提示',
//   lanauage === 'zh' ? '警告' : 'Warn',
//   lanauage === 'zh' ? '确认' : 'Confirm',
//   '温馨提示'];
export default {
  data() {
    return {
      defaultInfoCode: -1,
      titleCode: 0,
      options: {
        title: '',
        msg: '',
        btn1: {
          msg: '',
          func: ''
        },
        btn2: {
          msg: '',
          func: ''
        },
        confirm: null,
        cancel: null
      },
      animationSettings: { effect: 'None' },
      closeIcon: true,
      defaultTitle : []
    };
  },
  name: 'Layer',
  methods: {
    showLayer() {
      this.operTitleI18N();
      this.$refs.commonDialog.refreshPosition();
      this.$refs.commonDialog.show();
    },
    funcClose1() {
      if (this.options.btn1.func !== undefined) {
        this.options.btn1.func();
      }
      this.$refs.commonDialog.hide();
    },
    funcClose2() {
      if (this.options.btn2.func !== undefined) {
        this.options.btn2.func();
      }
      this.$refs.commonDialog.hide();
    },
    operTitleI18N() {
      const lanauage = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'zh';
      if (lanauage === 'zh') {
        this.defaultTitle = [
          '',
          '警告',
          '确认',
          ''
        ];
      } else {
        this.defaultTitle = [
          '',
          'Warn',
          'Confirm',
          ''
        ];
      }
    }
  },
  computed: {
    headerMessage() {
      if (this.options.title === undefined || this.options.title === '') {
        return this.defaultTitle[this.titleCode];
      }
      return this.options.title;
    },
    infoMessage() {
      if (this.defaultInfoCode === -1) {
        return this.options.msg;
      }
      return defaultInfo[this.defaultInfoCode];
    },
    btnMessage() {
      if (this.titleCode === 0 || this.options.btn1 === undefined) {
        return null;
      }
      if (this.options.btn1 !== undefined && this.options.btn2 !== undefined) {
        const btn1 = { click: this.funcClose1, buttonModel: { content: this.options.btn1.msg } };
        const btn2 = { click: this.funcClose2, buttonModel: { content: this.options.btn2.msg, isPrimary: true } };
        const btnGroup = [btn1, btn2];
        return btnGroup;
      }
      if (this.options.btn1 !== undefined && this.options.btn2 === undefined) {
        const btn1 = { click: this.funcClose1, buttonModel: { content: this.options.btn1.msg, isPrimary: true } };
        const btnGroup = [btn1];
        return btnGroup;
      }
      return null;
    },
  }
};
</script>

<style scoped>
</style>
